export default __webpack_public_path__ + "static/media/logo_svg.ead5cacb.svg";